import ProviderInfo from "@/model/provider/ProviderInfo"
import ProviderRole from "@/model/provider/ProviderRole"
import ProductType from "@/model/provider/ProductType"
import OfferTypeIds from "@/model/provider/OfferTypeIds"
import CreditType from "@/model/apply/CreditType"

import AffLogo from "@/assets/aspen/provider/logos/aff.png?url"
import FortivaLogo from "@/assets/aspen/provider/logos/fortiva.png?url"
import HFDLogoFrom from "@/assets/aspen/provider/logos/hfd.png?url"
import HFDBankLoanLogo from "@/assets/aspen/provider/logos/hatchbank.png?url"
import LendingClubLogo from "@/assets/aspen/provider/logos/lendingclub.png?url"
import ProceedLogo from "@/assets/aspen/provider/logos/proceed.png?url"
import LendingPointLogo from "@/assets/aspen/provider/logos/lendingpoint.png?url"
import CareCreditLogo from "@/assets/aspen/provider/logos/carecredit.png?url"
import PayMonthlyLogo from "@/assets/aspen/provider/logos/paymonthly.png?url"
import { ProviderProductType } from "@/model/apply/ProviderProductType.ts"

// TODO: do you think we should key by provider product.  Eg. Synchrony is CareCredit.
const Providers = {
    aff_standard: new ProviderInfo({
        providerId: "aff",
        name: "American First Finance",
        financingName: "Installment loan made by FinWise Bank sub-serviced by American First Finance",
        fundingSourceDescriptionByProductType: {
            [ProductType.FINWISE]: "Installment loan made by FinWise Bank sub-serviced by American First Finance",
            [ProductType.RISA]: "Retail installment contract by American First Finance",
        },
        paymentCalculatorRecalculatingModal: true,
        logo: AffLogo,
        showPaymentPlanDetails: true,
        maxDownPaymentCents: 5000,
        creditType: CreditType.LOAN,
    }),
    fortiva_standard: new ProviderInfo({
        providerId: "fortiva",
        name: "Fortiva Retail Credit",
        financingName: "Fortiva Retail Credit",
        fundingSourceDescription: "Fortiva Retail Credit",
        logo: FortivaLogo,
        creditType: CreditType.REVOLVING_CREDIT,
    }),
    hfd_standard: new ProviderInfo({
        providerId: "hfd",
        abbreviatedName: "HFD",
        name: "HFD",
        financingName: "HFD Installment Loan",
        fundingSourceDescription: "HFD Installment Loan",
        logo: HFDLogoFrom,
        footerLogo: {
            [ProductType.BANKLOAN]: HFDBankLoanLogo,
        },
        paymentCalculatorRecalculatingModal: true,
        fetchPaymentPlansOnResume: true,
        showDownPaymentAcknowledgeByProviderRoles: [ProviderRole.HIGHLINE_SECONDARY],
        showBankCardErrorModal: true,
        creditType: CreditType.LOAN,
    }),
    lendingclub_standard: new ProviderInfo({
        providerId: "lendingclub",
        name: "LendingClub",
        financingName: "LendingClub Bank, N.A.",
        fundingSourceDescription: "LendingClub",
        fetchPaymentPlansOnResume: true,
        logo: LendingClubLogo,
        selectPaymentPlanOnReviewScreen: true,
        creditType: CreditType.LOAN,
    }),
    proceed_standard: new ProviderInfo({
        providerId: "proceed",
        name: "Proceed Finance",
        fetchPaymentPlansOnResume: true,
        fetchPaymentPlansOnFullResume: true,
        fundingSourceDescription: "Proceed Finance",
        paymentCalculatorButtonsHidden: true,
        paymentCalculatorRecalculatingModal: true,
        logo: ProceedLogo,
        subLenders: [
            {
                providerId: "lendingpoint",
                name: "Proceed Finance's partner LendingPoint",
                financingName: "LendingPoint",
                logo: LendingPointLogo,
            },
        ],
        creditType: CreditType.LOAN,
    }),
    synchrony_standard: new ProviderInfo({
        providerId: "synchrony",
        name: "CareCredit Credit Card",
        financingName: "CareCredit Credit Card",
        fundingSourceDescription: "CareCredit Credit Card",
        logo: CareCreditLogo,
        fetchPaymentPlansOnResume: true,
        supportsFullAppMode: true,
        paymentPlanFilterOverrides: [
            {
                filterKey: "credit-card",
                types: [OfferTypeIds.DEFERRED_INTEREST, OfferTypeIds.FIXED_RATE],
            },
        ],
        creditType: CreditType.REVOLVING_CREDIT,
        canFinishWithExistingAccount: true,
        providerProductType: ProviderProductType.CREDIT,
        altProduct: {
            id: "paymonthly",
            name: "PayMonthly",
            financingName: "Pay Later",
            logo: PayMonthlyLogo,
        },
    }),
}

Object.keys(Providers).forEach(providerKey => (Providers[providerKey].providerKey = providerKey))

export default Providers
